import { computed, inject, Service, signal } from '@angular/core';
import { MgsWebApi } from '../mgs-webapi.service';
import {
  CODETABLE_TYP_LABORPROTOKOLLSTATUS,
  CODETABLE_TYP_PROGRAMMGRUPPE,
  CODETABLE_TYP_TIME4ME,
  codetableListToOptions,
  ICodetableItem
} from '@mng/mgs-lib';
import { firstValueFrom } from 'rxjs';

@Service()
export class CodetableService {
  readonly webApi = inject(MgsWebApi);
  codetableEntryGroups = signal<{ [type: string]: ICodetableItem[] }>(undefined);

  laborProtokollStati = computed(() => this.getByTyp(CODETABLE_TYP_LABORPROTOKOLLSTATUS));
  time4MeGruppen = computed(() => this.getByTyp(CODETABLE_TYP_TIME4ME));
  programmGruppen = computed(() => this.getByTyp(CODETABLE_TYP_PROGRAMMGRUPPE));
  programmGruppeOptions = computed(() => codetableListToOptions(this.programmGruppen(), false));

  async resolveCodetableEntries(): Promise<{ [type: string]: ICodetableItem[] }> {
    if (!this.codetableEntryGroups()) {
      this.codetableEntryGroups.set(await firstValueFrom(this.webApi.codetableEntries()));
    }
    return this.codetableEntryGroups();
  }

  private getByTyp(typ: string): ICodetableItem[] {
    if (!this.codetableEntryGroups()) {
      console.error(
        'CodetableEntries ist nicht initialisiert -> möglicherweise die Ausführung von codetableResolver sicherstellen'
      );
      return [];
    }
    return this.codetableEntryGroups()[typ] ?? [];
  }
}
